import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import '../../styles/ModalSaveTraining.css';

interface ModalSaveTrainingProperties {
  isVisible: boolean;
  onClose: () => void;
  onSave: (name: string, asRace: boolean) => void;
}

const ModalSaveTraining: React.FC<ModalSaveTrainingProperties> = ({
  isVisible,
  onClose,
  onSave,
}) => {
  const { t } = useTranslation('common');
  const [trainingName, setTrainingName] = useState('');
  const [saveAsRace, setSaveAsRace] = useState(false);

  const handleClose = () => {
    setTrainingName('');
    setSaveAsRace(false);
    onClose();
  };

  const handleSave = () => {
    if (trainingName.trim() === '') {
    } else {
      onSave(trainingName.trim(), saveAsRace);
      setTrainingName('');
      setSaveAsRace(false);
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="saveTrainingOverlay"
      role="button"
      aria-label={t('common.close', 'Close')}
      tabIndex={0}
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          handleClose();
        }
      }}
      onKeyDown={(event) => {
        if (event.key === 'Escape') {
          handleClose();
        }
      }}
    >
      <div
        className="saveTrainingContainer"
        role="dialog"
        aria-modal="true"
        aria-labelledby="saveTrainingTitle"
        tabIndex={-1}
      >
        <div className="saveTrainingHeader">
          <h2 id="saveTrainingTitle">{t('training.saveTitle', 'Save highlight')}</h2>
        </div>
        <div className="saveTrainingBody">
          <label htmlFor="trainingName">{t('training.nameLabel', 'Name:')}</label>
          <input
            id="trainingName"
            type="text"
            value={trainingName}
            onChange={(event) => setTrainingName(event.target.value)}
          />
          <div className="saveTrainingType">
            <span className="saveTrainingTypeLabel">
              {t('training.typeLabel', 'Save as')}
            </span>
            <label className="saveTrainingRadio">
              <input
                type="radio"
                name="save-type"
                value="training"
                checked={!saveAsRace}
                onChange={() => setSaveAsRace(false)}
              />
              {t('training.trainingOption', 'Training')}
            </label>
            <label className="saveTrainingRadio">
              <input
                type="radio"
                name="save-type"
                value="race"
                checked={saveAsRace}
                onChange={() => setSaveAsRace(true)}
              />
              {t('training.raceOption', 'Race')}
            </label>
          </div>
        </div>
        <div className="saveTrainingFooter">
          <button className="saveTrainingBtn cancelBtn" onClick={handleClose}>
            {t('common.cancel')}
          </button>
          <button className="saveTrainingBtn saveBtn" onClick={handleSave}>
            {t('common.save')}
          </button>
        </div>
      </div>
    </div>
  );
};

export { ModalSaveTraining };
